import { render, staticRenderFns } from "./SortingParams.vue?vue&type=template&id=17eb7898&scoped=true"
import script from "./SortingParams.vue?vue&type=script&lang=js"
export * from "./SortingParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eb7898",
  null
  
)

export default component.exports